<template>
  <div class="animated fadeIn dashboard pb-8">
    <div v-if="!loaded" class="d-flex flex-column align-items-center mt-8 py-6">
      <atom-spinner :animation-duration="1000" :size="80" :color="'#6200ea'" />
      <p class="primary--text font-weight-bold mt-4">
        در حال بارگذاری اطلاعات...
      </p>
    </div>
    <div v-else>
      <v-row class="header">
        <v-col class="col" lg="3" md="6" cols="12">
          <v-card class="common-card">
            <div class="d-flex flex-row">
              <div class="purple-iconBox">
                <v-icon>$Warehouse</v-icon>
              </div>
              <span class="box-header">موجودی انبار</span>
            </div>
            <h5>
              {{ Number(dashboard.warehouseItems).toLocaleString() }} کالا
            </h5>
          </v-card>
        </v-col>
        <v-col class="col" lg="3" md="6" cols="12">
          <v-card class="common-card">
            <div class="d-flex flex-row">
              <div class="blue-iconBox">
                <v-icon>$Wallet</v-icon>
              </div>
              <span class="box-header">میزان فروش</span>
            </div>
            <h5>{{ Number(dashboard.totalIncome).toLocaleString() }} تومان</h5>
          </v-card>
        </v-col>
        <v-col class="col" lg="3" md="6" cols="12">
          <v-card class="common-card">
            <div class="d-flex flex-row">
              <div class="red-iconBox">
                <v-icon>$Customer</v-icon>
              </div>
              <span class="box-header">تعداد مشتری</span>
            </div>
            <h5>{{ Number(dashboard.shopCustomers).toLocaleString() }} نفر</h5>
          </v-card>
        </v-col>
        <v-col class="col" lg="3" md="6" cols="12">
          <v-card class="common-card">
            <div class="d-flex flex-row">
              <div class="green-iconBox">
                <v-icon>$Box</v-icon>
              </div>
              <span class="box-header"> کل محصولات</span>
            </div>
            <h5>
              {{ Number(dashboard.productSum).toLocaleString() }} نوع کالا
            </h5>
          </v-card>
        </v-col>
      </v-row>
      <!--      <div class="mt-5">-->
      <!--        <v-card class="common-card">-->
      <!--          <div class="d-flex flex-row">-->
      <!--            <div class="orange-iconBox mt-1">-->
      <!--              <v-icon>$Chart2</v-icon>-->
      <!--            </div>-->
      <!--            <span class="c-grey pt-3 ps-3">نمودار میزان درآمد</span>-->
      <!--          </div>-->
      <!--          <div class="mt-6">-->
      <!--            <Chart-->
      <!--              name="lineChart"-->
      <!--              type="line"-->
      <!--              v-if="showChart"-->
      <!--              :chartdata="dashboard.incomes"-->
      <!--              :options="optionsLine"-->
      <!--              height="160"-->
      <!--            >-->
      <!--            </Chart>-->
      <!--          </div>-->
      <!--        </v-card>-->
      <!--      </div>-->
      <div class="mt-5">
        <v-row>
          <v-col lg="12" cols="12">
            <v-card class="common-card">
              <div class="d-flex flex-row">
                <div class="blue-iconBox">
                  <v-icon>$BoxChecked</v-icon>
                </div>
                <span class="c-grey ms-4 pt-2"
                  >پرفروش‌ترین کالاهای این ماه</span
                >
              </div>
              <div class="custom-table mt-5">
                <b-table
                  responsive
                  show-empty
                  :items="dashboard.bestSelling"
                  :fields="fields"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  striped
                  thead-class="headClass"
                  tbody-class="bodyClass"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:head(name)="data">
                    <div style="text-align: right; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div
                      style="
                        text-align: right;
                        vertical-align: middle;
                        min-width: 300px;
                      "
                    >
                      {{
                        data.value.length > 40
                          ? data.value.slice(0, 40) + "..."
                          : data.value
                      }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ Number(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
              </div>
            </v-card>
          </v-col>
          <!--          <v-col lg="6" cols="12">-->
          <!--            <v-card class="common-card">-->
          <!--              <div class="d-flex flex-row">-->
          <!--                <div class="blue-iconBox">-->
          <!--                  <v-icon>$FinishedBox</v-icon>-->
          <!--                </div>-->
          <!--                <span class="c-grey ms-4 pt-2">کالاهای با موجودی تمام شده</span>-->
          <!--              </div>-->
          <!--              <div class="custom-table mt-5">-->
          <!--                <b-table-->
          <!--                  responsive-->
          <!--                  show-empty-->
          <!--                  :items="dashboard.zero"-->
          <!--                  :fields="fields2"-->
          <!--                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"-->
          <!--                  empty-text="رکوردی برای نمایش وجود ندارد"-->
          <!--                  striped-->
          <!--                  thead-class="headClass"-->
          <!--                  tbody-class="bodyClass"-->
          <!--                >-->
          <!--                  <template v-slot:head()="data">-->
          <!--                    <div style="text-align: center; vertical-align: middle">-->
          <!--                      {{ data.label }}-->
          <!--                    </div>-->
          <!--                  </template>-->
          <!--                  <template v-slot:head(name)="data">-->
          <!--                    <div style="text-align: right; vertical-align: middle">-->
          <!--                      {{ data.label }}-->
          <!--                    </div>-->
          <!--                  </template>-->
          <!--                  <template v-slot:cell()="data">-->
          <!--                    <div style="text-align: center; vertical-align: middle">-->
          <!--                      {{ data.value }}-->
          <!--                    </div>-->
          <!--                  </template>-->
          <!--                  <template v-slot:cell(name)="data">-->
          <!--                    <div-->
          <!--                      style="-->
          <!--                        text-align: right;-->
          <!--                        vertical-align: middle;-->
          <!--                        min-width: 300px;-->
          <!--                      "-->
          <!--                    >-->
          <!--                      {{-->
          <!--                        data.value.length > 40-->
          <!--                          ? data.value.slice(0, 40) + "..."-->
          <!--                          : data.value-->
          <!--                      }}-->
          <!--                    </div>-->
          <!--                  </template>-->
          <!--                  <template v-slot:cell(price)="data">-->
          <!--                    <div style="text-align: center; vertical-align: middle">-->
          <!--                      {{ Number(data.value).toLocaleString() }}-->
          <!--                    </div>-->
          <!--                  </template>-->
          <!--                </b-table>-->
          <!--              </div>-->
          <!--            </v-card>-->
          <!--          </v-col>-->
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import Chart from "../../components/charts/Chart.vue";
import moment from "moment-jalaali";
import { AtomSpinner } from "epic-spinners";
export default {
  components: {
    Chart,
    AtomSpinner,
  },
  data() {
    return {
      moment: moment,
      loaded: false,
      currentYear: moment(new Date()).format("jYYYY"),
      selectedYear: moment(new Date()).format("jYYYY"),
      years: [],
      dashboard: {},
      bestSelling: [],
      finishedGoods: [],
      dataLine: {},
      showChart: false,
      optionsLine: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            rtl: true,
            display: false,
            position: "top",
            labels: {
              font: {
                family: "iranyekan",
              },
              boxWidth: 25,
              boxHeight: 8,
            },
          },
          tooltip: {
            titleFont: {
              family: "iranyekan",
            },
            bodyFont: {
              family: "iranyekan",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            min: 0,
            title: {
              display: true,
              text: "میزان درآمد (میلیون تومان)",
              font: { family: "iranyekan" },
            },
            grid: {
              display: false,
            },
            ticks: {
              label: "میزان درآمد (میلیون تومان)",
              stepSize: 10,
              beginAtZero: true,
              font: { family: "iranyekan" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iranyekan",
              },
            },
          },
        },
      },
      fields: [
        { key: "name", label: "نام محصول" },
        { key: "purchaseCount", label: " تعداد فروش" },
        { key: "price", label: "قیمت (تومان)" },
        { key: "warehouseStocks", label: "موجودی انبار" },
      ],
      // fields2: [
      //   { key: "name", label: "نام محصول" },
      //   { key: "price", label: "قیمت (تومان)" },
      //   { key: "purchaseCount", label: "تعداد فروش" },
      // ],
    };
  },

  methods: {
    getDashboard() {
      Axios.post(
        this.baseUrl + "/satrapp/user/dashboard",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.dashboard = res.data;
      
            setTimeout(() => {
              this.showChart = true;
              this.loaded = true;
            }, 100);
          } else {
            this.toast(res.data, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getDashboard();
  },
};
</script>

<style lang="scss">
.dashboard {
  .header {
    .v-card {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 140px;

      .box-header {
        color: #656a81;
        padding-top: 7px;
        padding-right: 14px;
      }
      h5 {
        color: #4e536a;
        font-size: 20px;
        margin: 0;
      }
    }
  }
  .customSelect {
    border: 1px solid #4ba0e7;
    padding: 5px 13px 6px;
    width: 110px;
    border-radius: 8px;
    path {
      stroke: #4ba0e7;
    }
    .v-text-field > .v-input__control > .v-input__slot {
      &::before,
      &::after {
        display: none !important;
      }

      .v-select__selection {
        color: #4ba0e7 !important;
        font-size: 14px;
        transform: translateY(-2px);
      }
    }
  }
}
</style>
